/**
 * Ułamki etatu — skok co 1/8 = 0.125.
 * Wartości precyzyjne do 3 miejsc po przecinku (Postgres Decimal(4,3)).
 * UI label jest ludzkim opisem ułamka.
 */
export const EMPLOYMENT_FRACTIONS = [
    { value: 0.125, label: '1/8 etatu' },
    { value: 0.250, label: '1/4 etatu' },
    { value: 0.375, label: '3/8 etatu' },
    { value: 0.500, label: '1/2 etatu' },
    { value: 0.625, label: '5/8 etatu' },
    { value: 0.750, label: '3/4 etatu' },
    { value: 0.875, label: '7/8 etatu' },
    { value: 1.000, label: 'Pełny etat' },
];
const VALID_VALUES = new Set(EMPLOYMENT_FRACTIONS.map((f) => f.value));
/** Sprawdza czy liczba jest jedną z dozwolonych wartości {0.125, 0.250, ..., 1.000}. */
export function isValidEmploymentFraction(n) {
    return VALID_VALUES.has(n);
}
/**
 * Format ułamka do wyświetlenia w UI: 0.500 → "1/2", 0.625 → "5/8", 1.000 → "1/1".
 * Skraca ułamek do najprostszej postaci z mianownikiem ∈ {1, 2, 4, 8}.
 */
export function formatEmploymentFraction(n) {
    const eighths = Math.round(n * 8);
    if (eighths <= 0 || eighths > 8)
        return String(n);
    // NWD(eighths, 8) — 8 ma dzielniki {1, 2, 4, 8}
    const divisors = [1, 2, 4, 8];
    let gcd = 1;
    for (const d of divisors) {
        if (eighths % d === 0 && 8 % d === 0)
            gcd = d;
    }
    return `${eighths / gcd}/${8 / gcd}`;
}
//# sourceMappingURL=employment-fraction.js.map